export const categories = [
  { slug: 'mingxing', name: '明星爆料', icon: 'ri-star-line', description: '汇聚娱乐圈明星最新黑料与爆料资讯' },
  { slug: 'wanghong', name: '网红黑料', icon: 'ri-live-line', description: '追踪网红圈内幕与热门爆料事件' },
  { slug: 'yulequan', name: '娱乐圈', icon: 'ri-movie-line', description: '娱乐圈全方位八卦与内幕消息' },
  { slug: 'shehui', name: '社会热点', icon: 'ri-fire-line', description: '社会热点事件追踪与深度爆料' },
  { slug: 'zuixin', name: '最新爆料', icon: 'ri-flashlight-line', description: '24小时实时更新最新爆料内容' },
];

export const hotTags = [
  '某顶流塌房', '网红翻车', '综艺黑幕', '选秀内定', '明星恋情',
  '直播带货', '偷税漏税', '代孕风波', '假唱曝光', '潜规则',
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find(c => c.slug === slug) || categories[0];
};